import type { TimeseriesDataPoint } from './shared.ts'

export const aiUsageTypes = [
  'chat',
  'document',
  'chat-analysis',
  'chat-aggregation',
  'address-import',
] as const
export type AiUsageType = (typeof aiUsageTypes)[number]

export type AiUsageTimeseriesResult = TimeseriesDataPoint

export type AiUsageTotalResult = {
  accountId: string
  totalTokens: number
}

export type AiUsageChatResult = {
  accountId: string
  totalTokens: number
  totalChats: number
  totalUserMessages: number
  tokenLimit: number
}
